const buildDeploymentBody = values => ({
  codename: values.codename,
  description: values.description,
  connectivity_fixed_ip: values.connectivityFixedIp,
  mobile_box: values.mobileBox,
  usually_disconnected: values.usuallyDisconnected,
  allow_concurrent_events: values.allowsConcurrentEvents,
  allow_qod: values.allowQod,
  msisdn_qod: values.allowQod ? values.msisdnQod : undefined,
  ...(values.ownedByPartnerId ? { owned_by_partner_id: values.ownedByPartnerId } : {}),
  contacts: values.contacts,
  proxy_ptz: values.proxyPtz ? values.proxyPtz : undefined,
  aws_elastic_ip: values.awsElasticIps ? values.awsElasticIps.map(ip => ip.trim()) : undefined,
  place: values.place
    ? {
        name: values.place.name,
        telephone: values.place.telephone,
        address: values.place.address,
        server_ntp: values.place.serverNtp,
        time_zone: values.place.timeZone,
        daylight_saving: values.place.daylightSaving,
        geo: values.place.geo
          ? {
              latitude: Number(values.place.geo.latitude),
              longitude: Number(values.place.geo.longitude),
            }
          : undefined,
      }
    : undefined,
});

export default buildDeploymentBody;
